import { useEffect } from 'react';
import { t } from '@lingui/macro';
import { BaseLayout } from 'components/Layout/BaseLayout/BaseLayout';
import { useTutorials } from 'components/PortalTours/hooks/useTutorials.hook';
import { StandAloneCalculator } from 'components/StandAloneCalculator/StandAloneCalculator';
import { useSearchParams } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import styles from './calculator.module.css';

export const CalculatorPage = () => {
  const [searchParams] = useSearchParams();
  const hasPortalToursCookie = Boolean(getCookie('showPortalTours'));
  const hasShowCalculatorTourParams = searchParams.get('_showTour') === 'true';
  const { triggerCalculatorTour, shouldShowTour } = useTutorials(
    !hasShowCalculatorTourParams,
  );

  useEffect(() => {
    if (
      (hasShowCalculatorTourParams || shouldShowTour.calculator) &&
      hasPortalToursCookie
    ) {
      triggerCalculatorTour();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, shouldShowTour.calculator, hasPortalToursCookie]);

  return (
    <BaseLayout
      className={styles.container}
      pageTitle={t`Calculator | Introducer Portal`}
    >
      <StandAloneCalculator />
    </BaseLayout>
  );
};
